<template>
	<div>
		<div class="p-fluid">
			<DataTable 
			:value="config_table" 
			:scrollable="true"
      scrollHeight="500px"
			:paginator="true" :rows="10"
				dataKey="id" :rowHover="true" :filters="filters"
				paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
				:rowsPerPageOptions="[10,20,50]"
				currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}">
				<template #header>
					<div class="table-header p-col-6 p-lg-3" style="margin-left:auto">
						<span class="p-input-icon-left">
							<i class="pi pi-search"/><InputText v-model="filters['global']" :placeholder="$t('searchHeader')"/>
						</span>
					</div>
				</template>
				<template #empty>{{$t('TableEmpty')}}</template>
				<Column field="config_key" header="KEY" :sortable="true" headerStyle="width: 10rem">
					<template #body="dataTable">
						<div hidden>{{dataTable.data.config_id}}</div>
						{{dataTable.data.config_key}}
					</template>
				</Column>
				<Column field="config_detail" :header="$t('description')" :sortable="true" headerStyle="width: 10rem">
					<template #body="dataTable">
						{{dataTable.data.config_detail}}
					</template>
				</Column>
				<Column field="config_value" header="Value" :sortable="true" headerStyle="width: 10rem">
					<template #body="dataTable" >
						{{dataTable.data.config_value}}
					</template>
				</Column>
				<Column :header="$t('controlTable')" headerStyle="width: 10rem">
					<template #body="dataTable">
						<div class="p-formgrid p-grid">
							<div class="p-field p-col-4">
								<Button @click="configModal = true; editData(dataTable.data.config_id); temp = dataTable.data.config_id" icon="pi pi-pencil" :label="$t('editBtn')" class="p-button-rounded p-button-warning" />
							</div>
						</div>
					</template>
				</Column>	
			</DataTable>
		</div>

		<!-- Manage config modal -->
		<Dialog  :modal="true" :visible.sync="configModal" :style="{width: '600px'}" :header="$t('config_modal_title')">
			<div class="confirmation-content">
				<label>{{$t('config_modal_subtitle')}}</label>
				<div class="p-fluid p-mt-3">
					<div class="p-formgrid p-grid p-col-12">
						<div class="p-field p-col-10">
							<label for="config_key">KEY</label>
							<InputText id="config_key" type="text" v-model="config_key" disabled/>
						</div>
						<div class="p-field p-col-2">
							<label for="config_value">VALUE</label>
							<InputText id="config_value" type="number"  min="0" @input="checkChar" v-model="config_value"/>
						</div>	
					</div>
					<div class="p-formgrid p-grid p-col-12">
						<div class="p-field p-col">
							<label for="config_description">{{$t('description')}}</label>
							<InputText id="config_description" type="text" v-model="config_description"/>
						</div>
					</div>
				</div>
			</div>
			<template #footer>
				<Button :label="$t('cancelBtn')" icon="pi pi-times" class="p-button-text" @click="clearData()"/>
				<Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="saveData()" />
			</template>
		</Dialog>
	</div>
</template>

<script>
 
export default {
	name: "admin-config",
	data() {
		return{
			config_table : [],
			filters: {},
			temp:null,
			selectedData : '',

			configModal : false,
			config_key : '',
			config_value : 0,
			config_description : '',
		}
	},
	watch:{

	},
	async created() {
		await this.axios.post(`${this.$url_service}/admin/config`, {
          body: {
              topic: 'get-table',
            }
        }).then(response => {this.config_table = response.data.data})
	},
	mounted() {
	},
	methods: {
		checkChar(e){
			if(e == ''){
				this.config_value = 0
			}
		},

		async editData(data){
			await this.axios.post(`${this.$url_service}/admin/config`, {
				body: {
					topic: 'get-one',
					id: data
				}
			}).then(response => {(this.selectedData = response.data.data),
								(this.config_key = response.data.data.config_key),
								(this.config_value = response.data.data.config_value),
								(this.config_description = response.data.data.config_detail)})
		},

		async saveData(){
			this.configModal = false;
			await this.axios.post(`${this.$url_service}/admin/config`, {
				body: {
					topic: 'edit-config',
					id: this.temp,
					value: this.config_value,
					detail: this.config_description
				}
			}).then(response => (this.config_table = response.data.data))
			// this.$toast.add({severity:'success', summary: 'แก้ไขข้อมูลสำเร็จ', detail:`ข้อมูล Configuration`, life: 3000});
			this.$fire({
              title: "แก้ไขข้อมูลสำเร็จ",
              text: `ข้อมูล Configuration`,
              type: "success",
              timer: 3000,
              confirmButtonColor: '#28B463',
            });
		},

		clearData(){
			this.temp = null
			this.displayConfirmation = false
			this.configModal = false
			this.selectedData = ''
			this.config_value = 0
			this.config_description = ''
		}
	}
}
</script>

<style scoped>
	.p-field {
		margin-bottom: 0rem;
	}
</style>

<style>
.p-datatable-thead{
	border: 2px solid #d6d6d6;
}

.p-datatable-tbody{
	border: 2px solid #d6d6d6;
}
</style>
